import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import Route from "./routes";

import MeusCupons from "../pages/MeusCupons";

import SairNode from "../pages/LoginNode/sair";
import OAuth from "../pages/OAuth";
import Logout from "../pages/OAuth/Logout";
// import PainelEmpresa from "../pages/PainelEmpresa/index";
// import PortalAluno from "../pages/PainelEmpresa/portalAluno";
// import RelatorioGeral from "../pages/PainelEmpresa/relatorioGeral";

// Online

import Certificados from "../pages/Online/Certificados";

import Tickets from "../pages/Online/Tickets";
import TicketsEdit from "../pages/Online/Tickets/Editar";

// Testes

// Migração
import InserirVoittoCoins from "../pages/Admin/Alunos/Insercaovts";
import AtribuirSimulado from "../pages/Admin/AtribuirSimulado";
import ControleIndicacoes from "../pages/Admin/ControleIndicacoes";
import SpecialsVounchers from "../pages/Admin/ControleIndicacoes/specialsVouchers";
import ListarCursos from "../pages/Admin/Cursos/ListarCursos";
import RedirecionamentoTreinamento from "../pages/Admin/Cursos/Redirecionamento";
import PedidosExtensao from "../pages/Admin/Ead/PedidosExtensao/Listar";
import AdminHome from "../pages/Admin/Home";
import AdminHomeNova from "../pages/Admin/Home/home";
import Logs from "../pages/Admin/Logs";
import Parceiros from "../pages/Admin/Parceiros";
// import ParceirosTeste from "../pages/Admin/Parceiros/Pedidos";
import PocketDia from "../pages/Admin/PocketForYou/PocketDia";
import PresenciaisTreinamento from "../pages/Admin/Presencial/Treinamento";
import Inscricoes from "../pages/Admin/inscricoes";

import CriarSimulados from "../pages/Admin/simulados/Criar";
import EditarSimulados from "../pages/Admin/simulados/Editar";
import ListarSimulados from "../pages/Admin/simulados/listar";

import EditarCursos from "../pages/Admin/Ead/Cursos/editar";
import EditarLicoesCursos from "../pages/Admin/Ead/Cursos/editar/licoes";
import CriarLicoesCursos from "../pages/Admin/Ead/Cursos/editar/licoes/criar";
import ListarEadCursos from "../pages/Admin/Ead/Cursos/listar";

import CriarTeste from "../pages/Admin/Ead/Testes/Criar";
import EditarTeste from "../pages/Admin/Ead/Testes/Editar";
import ListarTestes from "../pages/Admin/Ead/Testes/Listar";

import EditarTestesResultados from "../pages/Admin/Ead/TestesResultados/Editar";
import ListarTestesResultados from "../pages/Admin/Ead/TestesResultados/Listar";

import EditarAcademyCursos from "../pages/Admin/AcademyCursos/Editar";
import ListarAcademyCursos from "../pages/Admin/AcademyCursos/Listar";

import ListarAcademyHistories from "../pages/Admin/AcademyHistories/Listar";

import PushNotificacoes from "../pages/Admin/notificacoes/Push";

import GeradorCertificadoListar from "../pages/Admin/GeradorCertificadoListar";

import HistoriasDeSucessoCriar from "../pages/Admin/HistoriasDeSucesso/Criar";
import HistoriasDeSucessoEditar from "../pages/Admin/HistoriasDeSucesso/Editar";
import HistoriasDeSucessoListar from "../pages/Admin/HistoriasDeSucesso/Listar";

import ConteudoTreinamentoCriar from "../pages/Admin/Cursos/Conteudo/Criar";
import ConteudoTreinamentoEditar from "../pages/Admin/Cursos/Conteudo/Editar";
import ConteudoTreinamento from "../pages/Admin/Cursos/Conteudo/listar";

import FaqCriar from "../pages/Admin/Banner/faq/CriarFaq";
import CreateFaqSegment from "../pages/Admin/Banner/faq/CreateFaqSegment";
import FaqEditar from "../pages/Admin/Banner/faq/Editar";
import EditSegment from "../pages/Admin/Banner/faq/EditSegment";
import FaqListar from "../pages/Admin/Banner/faq/listar";
import ListarDetalhes from "../pages/Admin/Banner/faq/ListarDetalhes";

import PremiumListar from "../pages/Admin/Ead/AtualizacaoPremium/listar";

import BarrasEventos from "../pages/Admin/BarrasEventos";

import CardCombosCriar from "../pages/Admin/CardCombos/criar/";
import CardCombosEditar from "../pages/Admin/CardCombos/editar/";
import CardCombosListar from "../pages/Admin/CardCombos/listar/";

import CombosCriar from "../pages/Admin/Ead/CombosPlataforma/criar";
import CombosEditar from "../pages/Admin/Ead/CombosPlataforma/editar";
import CombosListar from "../pages/Admin/Ead/CombosPlataforma/listar";

import EmailCriar from "../pages/Admin/Emails/criarEmail";
import EmailListar from "../pages/Admin/Emails/listarEmails";
import EmailEditar from "../pages/Admin/Emails/updateEmail";

import criarDepoimento from "../pages/Admin/Depoimentos/criarDepoimento";
import editarDepoimento from "../pages/Admin/Depoimentos/editarDepoimento";
import listarDepoimento from "../pages/Admin/Depoimentos/listarDepoimentos";

import ConsultoresCriar from "../pages/Admin/Consultores/criar";
import ConsultoresEditar from "../pages/Admin/Consultores/editar";

import QuestaoCriar from "../pages/Admin/Questoes/criarQuestao";
import QuestaoEditar from "../pages/Admin/Questoes/editarQuestao";
import QuestaoListar from "../pages/Admin/Questoes/listarQuestoes";

import CriarEmpresas from "../pages/Admin/Empresas/criarEmpresas";
import EditarEmpresas from "../pages/Admin/Empresas/editarEmpresas";
import ListarEmpresas from "../pages/Admin/Empresas/listarEmpresas";
import ListagemSolicitacoesEmpresas from "../pages/Admin/Empresas/solicitacoesEmpresas";

import CriarBandeirasCart from "../pages/Admin/BandeirasCart/Criar";
import EditarBandeirasCart from "../pages/Admin/BandeirasCart/Editar";
import ListarBandeirasCart from "../pages/Admin/BandeirasCart/Listar";
import CriarPocketBook from "../pages/Admin/PocketForYou/Criar";
import EditarPocketBook from "../pages/Admin/PocketForYou/Editar";
import CadastroParceiros from "../pages/Admin/PocketForYou/Parceiros/CadastroParceiros";
import ListagemParceirosPocket from "../pages/Admin/PocketForYou/Parceiros/ListarParceiros";
import ListagemSolicitacoesParceiros from "../pages/Admin/PocketForYou/Parceiros/ListarSolicitacoesParceiros";
// import CriarTrilhas from "../pages/Admin/PocketForYou/Trilha/Criar";
// import EditarTrilhas from "../pages/Admin/PocketForYou/Trilha/Editar";
// import ListarTrilhas from "../pages/Admin/PocketForYou/Trilha/listar";
import EditarAlunosPocketBook from "../pages/Admin/PocketForYou/Usuario/Editar";
import ListarAlunosPocketBook from "../pages/Admin/PocketForYou/Usuario/listar";
import ListarPocketBook from "../pages/Admin/PocketForYou/listar";

import GratuitosQuarentena from "../pages/GratuitosQuarentena";
import LoginNode from "../pages/LoginNode";

import AdminTrocaCabecalho from "../pages/AdminTrocaCabecalho";

import PagamentoVindi from "../pages/PagamentoVindi";
import Pagar from "../pages/Pagar";

import Feedback from "../pages/Feedback";

// Refatoração de Telas

import IndicacaoShow from "../pages/IndicacaoShow";

// Admin
// import UploadTlss from "../pages/Admin/UploadTlss"; // desativado — rota /upload/tlss usa S3 tlss-files sem equivalente no file server

import RelatorioPersonalizacao from "../pages/Admin/Relatorios/personalizacao";
import RelatorioSubitens from "../pages/Admin/Relatorios/subitens";

import CertificadoOldDate from "../pages/Admin/Ead/Certificado-old-date";
import EadCertificadoCriar from "../pages/Admin/Ead/Certificados/Criar";
import EadCertificadoEditar from "../pages/Admin/Ead/Certificados/Editar";
import EadCertificadoListar from "../pages/Admin/Ead/Certificados/Listar";

import EadCertificadoTemplateCriar from "../pages/Admin/Ead/CertificadosTemplates/Criar";
import EadCertificadoTemplateEditar from "../pages/Admin/Ead/CertificadosTemplates/Editar";
import EadCertificadoTemplateListar from "../pages/Admin/Ead/CertificadosTemplates/Listar";

import CertificadosCursoCriar from "../pages/Admin/Ead/CertificadosCurso/Criar";
import CertificadosCursoEditar from "../pages/Admin/Ead/CertificadosCurso/Editar";
import CertificadosCurso from "../pages/Admin/Ead/CertificadosCurso/List";

import PersonaliteGerenciarCursos from "../pages/Admin/Personalite/GerenciarCursos";
import PersonaliteCursosDestaques from "../pages/Admin/Personalite/PersonaliteCursosDestaques";

import PessoaCursoPago from "../pages/Admin/PessoaCursoPago";
import PessoaWhiteBelt from "../pages/Admin/PessoaWhiteBelt";
import Relatorios from "../pages/Admin/Relatorios";
import RelatorioInscricoes from "../pages/Admin/Relatorios/Inscricoes";
import RelatorioListaEspera from "../pages/Admin/Relatorios/ListaEspera";
import RelatorioPesquisa from "../pages/Admin/Relatorios/Pesquisa";
import RelatorioPesquisaMBA from "../pages/Admin/Relatorios/PesquisaMBA";

import CreateCurso from "../pages/Admin/Cursos/CreateCurso";
import UpdateCurso from "../pages/Admin/Cursos/UpdateCurso";

import AlunosAdmin from "../pages/Admin/Alunos";
import UpdateAluno from "../pages/Admin/Alunos/Update";
import AlunoValidadeCurso from "../pages/Admin/Alunos/ValidadeCurso";

import ControleEnvios from "../pages/Admin/ControleEnvios";
import EadDuvidas from "../pages/Admin/Ead/Duvidas";
import EadOperacoes from "../pages/Admin/Ead/Operacoes";
import DuvidasEditar from "../pages/DuvidasEditar";

import AdminPaginaUploads from "../pages/Admin/PaginaUploads";
import PainelCarrosseis from "../pages/PainelCarrosseis";

import AnalyticCursos from "../pages/Admin/Analytic/Curso";
import PessoasCursoStatus from "../pages/Admin/Analytic/StatusCurso";

// import BlogContent from "../pages/Admin/Blog/Content";
import BlogFaixa from "../pages/Admin/Blog/Faixa";

import FaixaCriar from "../pages/Admin/Faixa/Criar";
import FaixaEditar from "../pages/Admin/Faixa/Editar";
import FaixaListar from "../pages/Admin/Faixa/Listar";

import AddTrailInBook from "../pages/Admin/PocketForYou/AddTrailInBook";
import Avaliacoes from "../pages/Admin/Pocketbook/Avaliacoes";
import AvaliacoesDetalhes from "../pages/Admin/Pocketbook/AvaliacoesDetalhes";
import ContasExcluidas from "../pages/Admin/Pocketbook/ContasExcluidas";
import PocketCupons from "../pages/Admin/Pocketbook/Cupons";
import PocketCuponsCriar from "../pages/Admin/Pocketbook/Cupons/Criar";
import PocketCuponsDetalhes from "../pages/Admin/Pocketbook/Cupons/Editar";
import ListarPlanos from "../pages/Admin/Pocketbook/ListarPlanos";
import LivrosRecomendados from "../pages/Admin/Pocketbook/LivrosRecomendados";
import PocketNominations from "../pages/Admin/Pocketbook/Nominations";
import Trial from "../pages/Admin/Pocketbook/Trial";

import Cupons from "../pages/Admin/Cupons";
import CreateCupom from "../pages/Admin/Cupons/Criar";
import CuponsEdit from "../pages/Admin/Cupons/Editar";
import CuponsRelatorio from "../pages/Admin/Cupons/relatorio";

import LogsVoittoCoins from "../pages/Admin/logsVoittoCoin";
import DetalhesLogsVoittoCoins from "../pages/Admin/logsVoittoCoin/detalhes";

import AnalyticData from "../pages/Admin/Analytic/DadosAbsolutos";
import DadosAlunoCursoStatus from "../pages/Admin/Analytic/DadosAlunosCursoStatus";

import AmeConciliacao from "../pages/Admin/AmeConciliacao";
import AmePedidos from "../pages/Admin/AmePedidos";

import WebPushNotifications from "../pages/Admin/Notifications/WebPush";

import Consultores from "../pages/Admin/Consultores";
import AlunosAtribuir from "../pages/Admin/Ead/AlunosAtribuir";
import GeradorCertificadoCriar from "../pages/Admin/GeradorCertificadoCriar";
import GerarPagamentos from "../pages/Admin/GerarPagamentos";
import PlanosLinkFuturo from "../pages/Admin/PlanosLinkFuturo";
import Pagamentos from "../pages/Admin/Pagamentos";
import PixPedidos from "../pages/Admin/PixPedidos";

import WebserieIndex from "../pages/Admin/Lives";

import WebserieEpisodio from "../pages/Admin/Lives/Episodio/";
import WebserieEpisodioAtualizar from "../pages/Admin/Lives/Episodio/Atualizar";
import WebserieEpisodioCriar from "../pages/Admin/Lives/Episodio/Criar";

import WebserieColaborador from "../pages/Admin/Lives/Colaboradores";
import WebserieColaboradorAtualizar from "../pages/Admin/Lives/Colaboradores/Atualizar";
import WebserieColaboradorCriar from "../pages/Admin/Lives/Colaboradores/Criar";

import WebseriePlaylist from "../pages/Admin/Lives/Playlist";
import WebseriePlaylistAtualizar from "../pages/Admin/Lives/Playlist/Atualizar";
import WebseriePlaylistCriar from "../pages/Admin/Lives/Playlist/Criar";

import Liberacao from "../pages/Admin/Cursos/Liberacao";
import GerarCertificado from "../pages/Admin/Ead/Certificados/Gerar";
import EventoEmailCriar from "../pages/Admin/Eventos/criarEmailEvento";
import EventoCriar from "../pages/Admin/Eventos/criarEvento";
import EventoEditar from "../pages/Admin/Eventos/editarEvento";
import EventoListar from "../pages/Admin/Eventos/listarEvento";
import ListaIndicacoes from "../pages/Admin/Eventos/listarIndicacoes";
import ListaIndicacoesAll from "../pages/Admin/Eventos/listarIndicacoesAll";
import RelatorioInscricoesMinificado from "../pages/Admin/Relatorios/InscricoesMinificado";
import Utm from "../pages/Admin/Relatorios/Utm";

import CriarCampaign from "../pages/Admin/Campaign/CreateCampaign";
import EditarCampaign from "../pages/Admin/Campaign/EditarCampaign";
import ListarCampaign from "../pages/Admin/Campaign/ListarCampaign";
import MarketingCampanhas from "../pages/Admin/Marketing/Campanhas";
import MapeamentodeCompetenciasListar from "../pages/Admin/MapeamentoDeCompetencias/Listar";
import MapeamentodeCompetenciasAlunos from "../pages/Admin/MapeamentoDeCompetencias/Alunos";
import CriarInscricoesEventos from "../pages/Admin/InscricoesEventos/Criar";
import EnviarEmailsInscricoesEventos from "../pages/Admin/InscricoesEventos/EnviarEmails";
import PerfilInscricoesEventos from "../pages/Admin/InscricoesEventos/Perfil";
import RelatorioPacotesVendidos from "../pages/Admin/Relatorios/PacotesVendidos";
import RelatorioTickets from "../pages/Admin/Relatorios/Tickets";
import VoittoAppRatings from "../pages/Admin/VoittoApp/Ratings";

import ValidadeCurso from "../pages/Admin/Alunos/ValidadeCurso";
import Indications from "../pages/Admin/Indications";
import LogsUser from "../pages/Admin/LogsUsers";
import Assinante from "../pages/Admin/Pagarme/Assinante";
import PagarmeAssinantes from "../pages/Admin/Pagarme/Assinantes";
import Inadimplentes from "../pages/Admin/Pagarme/Inadimplentes";
import PagarmePlanos from "../pages/Admin/Pagarme/Planos";
import Faturas from "../pages/Admin/Pagarme/Faturas";
import TransferirConta from "../pages/Admin/TransferirConta";
import CursoIncompletoNotificacao from "../pages/Admin/notificacoes/CursoIncompleto";
import VoittoJobs from "../pages/Admin/VoittoJobs";
import Planos from "../pages/Admin/Planos";
import TrailhasVoittoCriar from "../pages/Admin/TrailhasVoitto/Criar";
import TrailhasVoittoDetalhes from "../pages/Admin/TrailhasVoitto/Editar";
import TrailhasVoittoListar from "../pages/Admin/TrailhasVoitto/Listar";

import {
  CreateCertificate,
  ListCertificates,
} from "../pages/Admin/Certificates";
import CertificateBatchesList from "../pages/Admin/Certificates/Batches";
import BatchDetail from "../pages/Admin/Certificates/Batches/BatchDetail";
import BatchWizard from "../pages/Admin/Certificates/Batches/BatchWizard";
import NewAllInPage from "../pages/Admin/NewAllin";

import {
  NovoCriarEmpresas,
  NovoListarEmpresas,
  NovoEditarEmpresas,
} from "../pages/Admin/NovoEmpresas";
import { MBAList } from "../pages/MBA/MBAList";
import { MBAListOne } from "../pages/MBA/MBAListOne";
import { MBAListByUser } from "../pages/MBA/MBAListByUser";
import { MBAAtribuir } from "../pages/MBA/MBAAtribuir";
import { MBADocumentos } from "../pages/MBA/MBADocumentos";
import { MBARemover } from "../pages/MBA/MBARemover";
import { MBAListComplete } from "../pages/MBA/MBAListComplete";
import { VacancyList } from "../pages/Admin/RH/VacancyList";
import { BankOfTalents } from "../pages/Admin/RH/BankOfTalents";
import CreateVacancy from "../pages/Admin/RH/VacancyList/CreateVacancy";
import EditVacancy from "../pages/Admin/RH/VacancyList/EditVacancy";
import { MBAListOnePersist } from "../pages/MBA/MBAListOnePersist";
import MatriculasMBA from "../pages/Admin/Relatorios/MatriculasMBA";
import ProgressoMBA from "../pages/Admin/Relatorios/ProgressoMBA";
import CloseToExpiring from "../pages/Admin/Relatorios/CloseToExpiring";
import { RelatoriosEmpresas } from "../pages/Admin/NovoEmpresas/RelatoriosEmpresas";
import FaturasV2 from "../pages/Admin/Pagarme/FaturasV2";
import PagarmeBoleto from "../pages/Admin/Pagarme/Boleto";
import DashboardMBA from "../components/Admin/Dashboard/MBA";
import DashboardAluno from "../components/Admin/Dashboard/DashboardAluno";
import AccessBlockings from "../pages/Admin/AccessBlockings";
import RelatorioInadimplentes from "../pages/Admin/Relatorios/Inadimplentes";
import RelatorioInadimplentesBoleto from "../pages/Admin/Relatorios/InadimplentesBoleto";
import TestsResults from "../pages/Admin/Testes/Resultados";
import RelatorioPagamentosFututos from "../pages/Admin/Relatorios/PagamentosFuturos";
import RelatorioPagamentosPeriodo from "../pages/Admin/Relatorios/PagamentosPeriodo";
import ControleProjetoNovo from "../pages/Admin/ControleProjetosNovo";
import ListarTrilhasV2 from "../pages/Admin/TrailhasVoitto/ListarV2";
import ListarMapeamentoV2 from "../pages/Admin/MapeamentoDeCompetencias/AlunosV2";
import PedidosPeriodo from "../pages/Admin/Relatorios/PedidosPeriodo";
import PedidosProdutoPeriodo from "../pages/Admin/Relatorios/PedidosProdutoPeriodo";
import PesquisaFormsSite from "../pages/Admin/Relatorios/PesquisaFormsSite";
import ProductExtension from "../pages/Admin/ProductExtension";
import ListSurveys from "../pages/Admin/Survey/ListSurveys";
import EditSurvey from "../pages/Admin/Survey/EditSurvey";
import ResumosDeLicao from "../pages/Admin/ResumosDeLicao";
import SystemLogs from "../pages/Admin/SystemLogs";
import ReportFirstContact from "../pages/Admin/Relatorios/FirstContact";
import AlunosMBA from "../pages/Admin/Relatorios/AlunosMBA";

const Routes = () => {
  const adminPocketBook = [
    <Route
      exact
      path="/admin/blog/pocketbook4you/pocketDia"
      component={PocketDia}
    />,
    <Route
      exact
      path="/admin/blog/pocketbook4you/usuarios"
      component={ListarAlunosPocketBook}
    />,
    <Route
      exact
      path="/admin/blog/pocketbook4you/usuarios/detalhes/:id"
      component={EditarAlunosPocketBook}
    />,
    <Route
      exact
      path="/admin/blog/pocketbook4you/parceiros/cadastro"
      component={CadastroParceiros}
    />,
    //rota quebrada
    <Route
      exact
      path="/admin/blog/pocketbook4you/parceiros/listagemsolicitacoesparceiros"
      component={ListagemSolicitacoesParceiros}
    />,
    <Route
      exact
      path="/admin/blog/pocketbook4you/parceiros/listagemsparceiros"
      component={ListagemParceirosPocket}
    />,
  ];

  const adminRoutes = [
    //Home
    <Route exact path="/admin/admin-old" component={AdminHome} />,
    //Nova Home
    <Route exact path="/admin" component={AdminHomeNova} />,
    <Route exact path="/admin/ranking/indicacao" component={Indications} />,

    //Certificados Cursos
    <Route
      exact
      path="/admin/ead/certificados/cursos"
      component={CertificadosCurso}
    />,
    <Route
      exact
      path="/admin/ead/certificados/cursos/criar"
      component={CertificadosCursoCriar}
    />,
    <Route
      exact
      path="/admin/ead/certificados/cursos/editar/:id"
      component={CertificadosCursoEditar}
    />,

    //Layout Certificados
    <Route
      exact
      path="/admin/ead/certificados"
      component={EadCertificadoListar}
    />,
    <Route
      exact
      path="/admin/ead/certificados/criar"
      component={EadCertificadoCriar}
    />,
    <Route
      exact
      path="/admin/ead/certificados/gerar"
      component={GerarCertificado}
    />,
    <Route
      exact
      path="/admin/ead/certificados/editar/:id"
      component={EadCertificadoEditar}
    />,

    //Pedidos Extensão
    <Route
      exact
      path="/admin/ead/pedidosExtensao"
      component={PedidosExtensao}
    />,

    /* // Combos
    <Route exact path="/admin/combos" component={CardCombosListar} />,
    <Route exact path="/admin/combos/criar" component={CardCombosCriar} />,
    <Route
      exact
      path="/admin/combos/detalhes/:id"
      component={CardCombosEditar}
    />, */

    // Ead Combos
    <Route exact path="/admin/ead/combos" component={CombosListar} />,
    <Route exact path="/admin/ead/combos/criar" component={CombosCriar} />,
    <Route
      exact
      path="/admin/ead/combos/detalhes/:id"
      component={CombosEditar}
    />,

    //Consultores
    <Route exact path="/admin/consultores" component={Consultores} />,
    <Route
      exact
      path="/admin/consultores/criar"
      component={ConsultoresCriar}
    />,
    <Route
      exact
      path="/admin/consultores/detalhes/:id"
      component={ConsultoresEditar}
    />,

    //Empresas
    <Route exact path="/admin/empresas" component={ListarEmpresas} />,
    <Route
      exact
      path="/admin/empresas/solicitacoesEmpresas"
      component={ListagemSolicitacoesEmpresas}
    />,
    <Route exact path="/admin/empresas/criar" component={CriarEmpresas} />,
    <Route
      exact
      path="/admin/empresas/detalhes/:id"
      component={EditarEmpresas}
    />,

    // Novo Empresas
    <Route exact path="/admin/lms/criar" component={NovoCriarEmpresas} />,
    <Route exact path="/admin/lms" component={NovoListarEmpresas} />,
    <Route exact path="/admin/lms/:id" component={NovoEditarEmpresas} />,

    <Route exact path="/admin/pesquisa/novo" component={EditSurvey} />,
    <Route exact path="/admin/pesquisa" component={ListSurveys} />,
    <Route exact path="/admin/pesquisa/:id" component={EditSurvey} />,

    <Route
      exact
      path="/admin/empresas/relatorios"
      component={RelatoriosEmpresas}
    />,
    //<Route exact path="/admin/novo-empresas/solicitacoes" component={<div>Solicitações</div>} />,

    //Depoimentos
    <Route exact path="/admin/depoimentos" component={listarDepoimento} />,
    <Route exact path="/admin/depoimentos/criar" component={criarDepoimento} />,
    <Route
      exact
      path="/admin/depoimentos/detalhes/:id"
      component={editarDepoimento}
    />,

    //logs Voitto Coins
    <Route exact path="/admin/logsVoittoCoin" component={LogsVoittoCoins} />,
    <Route
      exact
      path="/admin/logsVoittoCoin/detalhes/:id"
      component={DetalhesLogsVoittoCoins}
    />,

    //Ead Cursos
    <Route exact path="/admin/ead/cursos" component={ListarEadCursos} />,
    <Route exact path="/admin/ead/cursos/:id" component={EditarCursos} />,
    <Route
      exact
      path="/admin/ead/cursos/:id/modulos"
      component={EditarCursos}
    />,
    <Route
      exact
      path="/admin/ead/cursos/:id_curso/modulos/:id/licoes"
      component={EditarLicoesCursos}
    />,
    <Route
      exact
      path="/admin/ead/cursos/:id_curso/modulos/:id/licoes/criar"
      component={CriarLicoesCursos}
    />,

    <Route exact path="/admin/ead/testes" component={ListarTestes} />,

    <Route exact path="/admin/ead/testes/criar" component={CriarTeste} />,

    <Route
      exact
      path="/admin/ead/testes/resultados"
      component={ListarTestesResultados}
    />,

    <Route
      exact
      path="/admin/ead/testes/resultados/:id_teste_resultado"
      component={EditarTestesResultados}
    />,

    <Route exact path="/admin/ead/testes/:id_teste" component={EditarTeste} />,

    <Route exact path="/admin/testes/resultados" component={TestsResults} />,

    //Cursos Conteudos
    <Route
      exact
      path="/admin/cursos/conteudo"
      component={ConteudoTreinamento}
    />,
    <Route
      exact
      path="/admin/cursos/conteudo/criar"
      component={ConteudoTreinamentoCriar}
    />,
    <Route
      exact
      path="/admin/cursos/conteudo/detalhes/:id"
      component={ConteudoTreinamentoEditar}
    />,
    <Route exact path="/admin/trilhas/criar" component={TrailhasVoittoCriar} />,
    <Route
      exact
      path="/admin/trilhas/detalhes/:id"
      component={TrailhasVoittoDetalhes}
    />,
    <Route exact path="/admin/trilhas/listar" component={ListarTrilhasV2} />,

    //Cursos
    <Route exact path="/admin/cursos" component={ListarCursos} />,

    <Route exact path="/admin/cursos/ativos" component={ListarCursos} />,
    <Route exact path="/admin/cursos/inativos" component={ListarCursos} />,

    //Faq
    <Route exact path="/admin/faq" component={FaqListar} />,
    <Route
      exact
      path="/admin/mapeamento-de-competencias"
      component={MapeamentodeCompetenciasListar}
    />,
    <Route
      exact
      path="/admin/alunos/mapeamento-de-competencias"
      component={ListarMapeamentoV2}
    />,
    <Route exact path="/admin/faq/criar" component={FaqCriar} />,
    <Route
      exact
      path="/admin/faq/criar-segmento"
      component={CreateFaqSegment}
    />,
    <Route exact path="/admin/faq/detalhes/:id" component={ListarDetalhes} />,
    <Route exact path="/admin/faq/edit/:id" component={FaqEditar} />,
    <Route exact path="/admin/faq/edit-segment/:id" component={EditSegment} />,

    //Inscrições
    <Route exact path="/admin/inscricoes" component={Inscricoes} />,

    //Presenciais Treinamentos
    <Route
      exact
      path="/admin/presenciais/treinamentos"
      component={PresenciaisTreinamento}
    />,

    //Redirecionamento Treinamento
    <Route
      exact
      path="/admin/cursos/redirecionamento_treinamento"
      component={RedirecionamentoTreinamento}
    />,

    //Parceiros
    <Route exact path="/admin/parceiros" component={Parceiros} />,

    //Pagamentos Gerar
    <Route
      exact
      path="/admin/pagamentos/gerar/:id_pessoa"
      component={GerarPagamentos}
    />,

    <Route exact path="/admin/extensao" component={ProductExtension} />,

    //Planos Link Futuro (Gestão Financeira)
    <Route
      exact
      path="/admin/planos/link-futuro"
      component={PlanosLinkFuturo}
    />,

    //Controle Envios
    <Route exact path="/admin/controle_envios" component={ControleEnvios} />,

    //Bandeiras
    <Route
      exact
      path="/admin/bandeiras_cart"
      component={ListarBandeirasCart}
    />,
    <Route
      exact
      path="/admin/bandeiras_cart/criar"
      component={CriarBandeirasCart}
    />,
    <Route
      exact
      path="/admin/bandeiras_cart/:id"
      component={EditarBandeirasCart}
    />,

    //Cupons
    <Route exact path="/admin/cupons" component={Cupons} />,
    <Route exact path="/admin/cupons/relatorio" component={CuponsRelatorio} />,
    <Route exact path="/admin/cupons/criar" component={CreateCupom} />,
    <Route exact path="/admin/cupons/:id" component={CuponsEdit} />,

    //Questoes Simulado
    <Route exact path="/admin/questoes" component={QuestaoListar} />,
    <Route exact path="/admin/questoes/criar" component={QuestaoCriar} />,
    <Route
      exact
      path="/admin/questoes/detalhes/:id"
      component={QuestaoEditar}
    />,

    //Emails
    <Route exact path="/admin/emails" component={EmailListar} />,
    <Route exact path="/admin/emails/criar" component={EmailCriar} />,
    <Route exact path="/admin/emails/detalhes/:id" component={EmailEditar} />,

    //Relatórios Personalização
    <Route
      exact
      path="/admin/relatorios/personalizacao"
      component={RelatorioPersonalizacao}
    />,

    //Relatórios Inadimplentes
    <Route
      exact
      path="/admin/relatorios/inadimplentes"
      component={RelatorioInadimplentes}
    />,

    //Relatórios Inadimplentes Boleto
    <Route
      exact
      path="/admin/relatorios/inadimplentes/boleto"
      component={RelatorioInadimplentesBoleto}
    />,

    //Relatórios Pagamentos Futuros
    <Route
      exact
      path="/admin/relatorios/pagamentos-futuros"
      component={RelatorioPagamentosFututos}
    />,

    //Relatórios Pagamentos Periodo
    <Route
      exact
      path="/admin/relatorios/pagamentos-periodo"
      component={RelatorioPagamentosPeriodo}
    />,

    //Relatórios Subitens
    <Route
      exact
      path="/admin/relatorios/subitens"
      component={RelatorioSubitens}
    />,
    //Analytic
    <Route exact path="/admin/analytic/cursos" component={AnalyticCursos} />,
    <Route
      exact
      path="/admin/analytic/pessoas_cursos_status"
      component={PessoasCursoStatus}
    />,
    <Route
      exact
      path="/admin/analytic/dados-absolutos"
      component={AnalyticData}
    />,
    <Route
      exact
      path="/admin/analytic/dados-aluno-por-cursos"
      component={DadosAlunoCursoStatus}
    />,

    //Histórias de Sucesso
    <Route
      exact
      path="/admin/historiasdesucesso"
      component={HistoriasDeSucessoListar}
    />,
    <Route
      exact
      path="/admin/historiasdesucesso/criar"
      component={HistoriasDeSucessoCriar}
    />,
    <Route
      exact
      path="/admin/historiasdesucesso/detalhes/:id"
      component={HistoriasDeSucessoEditar}
    />,

    //Alunos
    <Route
      exact
      path="/admin/alunos/voittocoins"
      component={InserirVoittoCoins}
    />,
    <Route exact path="/admin/transferir_conta" component={TransferirConta} />,
    <Route
      exact
      path="admin/alunos/validade-curso"
      component={ValidadeCurso}
    />,

    //Controle de Indicações
    <Route
      exact
      path="/admin/controle_indicacoes/specials_vouchers"
      component={SpecialsVounchers}
    />,

    //Logs
    <Route exact path="/admin/logs" component={Logs} />,
    <Route exact path="/admin/logspagamento" component={LogsUser} />,

    //Ame Pedidos
    <Route exact path="/admin/ame-pedidos" component={AmePedidos} />,

    <Route exact path="/admin/ame-conciliacao" component={AmeConciliacao} />,

    //Pix Pedidos
    <Route exact path="/admin/pix-pedidos" component={PixPedidos} />,

    //Atribuir Simulados
    <Route
      exact
      path="/admin/atribuir_simulados"
      component={AtribuirSimulado}
    />,

    //Controle Indicacoes
    <Route
      exact
      path="/admin/controle_indicacoes"
      component={ControleIndicacoes}
    />,

    <Route
      exact
      path="/admin/certificados/novo"
      component={CreateCertificate}
    />,

    <Route exact path="/admin/certificados" component={ListCertificates} />,

    <Route
      exact
      path="/admin/certificados/turmas"
      component={CertificateBatchesList}
    />,
    <Route
      exact
      path="/admin/certificados/turmas/nova"
      component={BatchWizard}
    />,
    <Route
      exact
      path="/admin/certificados/turmas/:id"
      component={BatchDetail}
    />,

    //Simulados
    <Route exact path="/admin/simulados" component={ListarSimulados} />,
    <Route exact path="/admin/simulados/criar" component={CriarSimulados} />,
    <Route
      exact
      path="/admin/simulados/detalhes/:id"
      component={EditarSimulados}
    />,

    <Route exact path="/admin/bloqueio-acesso" component={AccessBlockings} />,

    //Dispara Notificação

    <Route
      exact
      path="/admin/disparaNotificacao"
      component={WebPushNotifications}
    />,

    <Route
      exact
      path="/admin/notificacoes/push"
      component={PushNotificacoes}
    />,

    <Route
      exact
      path="/admin/notificacoes/cursoEmAndamento"
      component={CursoIncompletoNotificacao}
    />,

    //Atualização Premium

    <Route
      exact
      path="/admin/ead/atualizacao-premium"
      component={PremiumListar}
    />,

    //Certificado

    <Route
      exact
      path="/admin/ead/certificado/old-date"
      component={CertificadoOldDate}
    />,

    <Route
      exact
      path="/admin/ead/certificados/templates"
      component={EadCertificadoTemplateListar}
    />,
    <Route
      exact
      path="/admin/ead/certificados/templates/criar"
      component={EadCertificadoTemplateCriar}
    />,
    <Route
      exact
      path="/admin/ead/certificados/templates/editar/:id"
      component={EadCertificadoTemplateEditar}
    />,

    <Route
      exact
      path="/admin/gerador_certificados"
      component={GeradorCertificadoCriar}
    />,
    <Route
      exact
      path="/admin/gerador_certificados/listar"
      component={GeradorCertificadoListar}
    />,

    //Carrosseis

    <Route
      exact
      path="/admin/painel_carrosseis"
      component={PainelCarrosseis}
    />,

    //Cabeçalho Vendas

    <Route
      exact
      path="/admin/cabecalho-vendas"
      component={AdminTrocaCabecalho}
    />,

    //Relatórios

    <Route exact path="/admin/relatorios" component={Relatorios} />,

    <Route
      exact
      path="/admin/relatorios/inscricoes"
      component={RelatorioInscricoes}
    />,

    <Route exact path="/admin/relatorios/mba" component={MatriculasMBA} />,

    <Route
      exact
      path="/admin/relatorios/progresso/mba"
      component={ProgressoMBA}
    />,

    <Route
      exact
      path="/admin/relatorios/close-to-expiring"
      component={CloseToExpiring}
    />,

    <Route
      exact
      path="/admin/relatorios/pesquisa"
      component={RelatorioPesquisa}
    />,
    <Route
      exact
      path="/admin/relatorios/pesquisa-mba"
      component={RelatorioPesquisaMBA}
    />,

    <Route
      exact
      path="/admin/relatorios/espera"
      component={RelatorioListaEspera}
    />,

    <Route
      exact
      path="/admin/relatorios/inscricoes/minificado"
      component={RelatorioInscricoesMinificado}
    />,

    <Route
      exact
      path="/admin/relatorios/pacotes-vendidos"
      component={RelatorioPacotesVendidos}
    />,

    <Route
      exact
      path="/admin/relatorios/tickets"
      component={RelatorioTickets}
    />,

    <Route
      exact
      path="/admin/relatorios/pedidos-periodo"
      component={PedidosPeriodo}
    />,
    <Route
      exact
      path="/admin/relatorios/pedidos-produto-periodo"
      component={PedidosProdutoPeriodo}
    />,
    <Route
      exact
      path="/admin/relatorios/survey"
      component={PesquisaFormsSite}
    />,
    <Route
      exact
      path="/admin/relatorios/primeiro-contato"
      component={ReportFirstContact}
    />,
    <Route
      exact
      path="/admin/relatorios/alunos-mba"
      component={AlunosMBA}
    />,

    //Pessoas Cursos Aleatórios

    <Route
      exact
      path="/admin/pessoas_com_cursos_pagos"
      component={PessoaCursoPago}
    />,
    <Route
      exact
      path="/admin/pessoas_com_white_belt"
      component={PessoaWhiteBelt}
    />,

    //Faixas
    <Route exact path="/admin/blog/faixa" component={BlogFaixa} />,
    <Route exact path="/admin/faixas" component={FaixaListar} />,
    <Route exact path="/admin/faixas/criar" component={FaixaCriar} />,
    <Route exact path="/admin/faixas/editar/:id" component={FaixaEditar} />,

    //Cursos
    <Route exact path="/admin/cursos/criar" component={CreateCurso} />,
    <Route exact path="/admin/cursos/liberacao" component={Liberacao} />,
    <Route exact path="/admin/cursos/detalhes/:id" component={UpdateCurso} />,

    //Logs
    <Route exact path="/admin/logs-do-sistema" component={SystemLogs} />,

    //Alunos
    <Route exact path="/admin/alunos" component={AlunosAdmin} />,
    <Route
      exact
      path="/admin/alunos/validade-curso"
      component={AlunoValidadeCurso}
    />,
    <Route exact path="/admin/alunos/atribuir" component={AlunosAtribuir} />,
    <Route exact path="/admin/alunos/detalhes/:id" component={UpdateAluno} />,
    <Route exact path="/admin/alunos/new-allin" component={NewAllInPage} />,

    //Upload

    <Route exact path="/admin/upload/anexos" component={AdminPaginaUploads} />,
    // <Route exact path="/admin/upload/tlss" component={UploadTlss} />, // desativado — página desativada enquanto tlss-files não tiver equivalente no file server

    //Dúvidas
    <Route exact path="/admin/ead/duvidas" component={EadDuvidas} />,
    <Route
      exact
      path="/admin/ead/duvidas/editar/:idResposta"
      component={DuvidasEditar}
    />,

    //Operacoes
    <Route exact path="/admin/operacoes" component={EadOperacoes} />,

    //PocketBook

    <Route exact path="/admin/pocketbook/cupons" component={PocketCupons} />,
    <Route
      exact
      path="/admin/pocketbook/indique-e-ganhe"
      component={PocketNominations}
    />,
    <Route exact path="/admin/pocketbook/trial" component={Trial} />,
    <Route
      exact
      path="/admin/pocketbook/cupons/criar"
      component={PocketCuponsCriar}
    />,
    <Route
      exact
      path="/admin/pocketbook/cupons/detalhes/:id"
      component={PocketCuponsDetalhes}
    />,

    <Route exact path="/admin/pocketbook/planos" component={ListarPlanos} />,
    <Route
      exact
      path="/admin/pocketbook/contas-excluidas"
      component={ContasExcluidas}
    />,
    <Route
      exact
      path="/admin/pocketbook/livros-recomendados"
      component={LivrosRecomendados}
    />,
    <Route exact path="/admin/pocketbook/avaliacoes" component={Avaliacoes} />,
    <Route
      exact
      path="/admin/pocketbook/avaliacoes/detalhes/:id"
      component={AvaliacoesDetalhes}
    />,
    <Route
      exact
      path="/admin/pocketbook/avaliacoes/detalhes/:id"
      component={AvaliacoesDetalhes}
    />,
    <Route
      exact
      path="/admin/pocketbook/addTrailInBook"
      component={AddTrailInBook}
    />,

    <Route exact path="/admin/barras-eventos" component={BarrasEventos} />,

    <Route exact path="/admin/pagamentos" component={Pagamentos} />,

    //Pagarme
    <Route exact path="/admin/pagarme/planos" component={PagarmePlanos} />,
    <Route
      exact
      path="/admin/pagarme/assinantes"
      component={PagarmeAssinantes}
    />,
    <Route
      exact
      path="/admin/pagarme/assinante/:id_pessoa"
      component={Assinante}
    />,
    <Route
      exact
      path="/admin/pagarme/inadimplentes"
      component={Inadimplentes}
    />,
    <Route exact path="/admin/faturas" component={Faturas} />,
    <Route exact path="/admin/faturasV2" component={FaturasV2} />,
    <Route exact path="/admin/pagamentos/boleto" component={PagarmeBoleto} />,

    <Route exact path="/admin/planos/link" component={Planos} />,

    //Personalite
    <Route
      exact
      path="/admin/personalite/gerenciar_cursos"
      component={PersonaliteGerenciarCursos}
    />,

    <Route
      exact
      path="/admin/personalite/cursos_destaques"
      component={PersonaliteCursosDestaques}
    />,

    //Feedback Controle
    <Route exact path="/admin/feedback-controle" component={Feedback} />,
    <Route
      exact
      path="/admin/controle-de-projetos"
      component={ControleProjetoNovo}
    />,

    <Route exact path="/admin/eventos" component={EventoListar} />,
    <Route exact path="/admin/eventos/criar" component={EventoCriar} />,
    <Route exact path="/admin/eventos/editar/:id" component={EventoEditar} />,
    <Route exact path="/admin/eventos/email" component={EventoEmailCriar} />,
    <Route
      exact
      path="/admin/eventos/indicacoes-old"
      component={ListaIndicacoes}
    />,
    <Route
      exact
      path="/admin/eventos/indicacoes"
      component={ListaIndicacoesAll}
    />,
    // Webseries - Lives
    <Route exact path="/admin/webseries/" component={WebserieIndex} />,
    <Route
      exact
      path="/admin/webserie-episodio"
      component={WebserieEpisodio}
    />,
    <Route
      exact
      path="/admin/webserie-episodio/criar"
      component={WebserieEpisodioCriar}
    />,
    <Route
      exact
      path="/admin/webserie-episodio/update"
      component={WebserieEpisodioAtualizar}
    />,
    <Route
      exact
      path="/admin/webserie-colaborador"
      component={WebserieColaborador}
    />,
    <Route
      exact
      path="/admin/webserie-colaborador/criar"
      component={WebserieColaboradorCriar}
    />,
    <Route
      exact
      path="/admin/webserie-colaborador/update"
      component={WebserieColaboradorAtualizar}
    />,
    <Route
      exact
      path="/admin/webserie-playlist"
      component={WebseriePlaylist}
    />,
    <Route
      exact
      path="/admin/webserie-playlist/criar"
      component={WebseriePlaylistCriar}
    />,
    <Route
      exact
      path="/admin/webserie-playlist/update"
      component={WebseriePlaylistAtualizar}
    />,
    <Route
      exact
      path="/admin/academy/cursos"
      component={ListarAcademyCursos}
    />,
    <Route exact path="/admin/campaign" component={ListarCampaign} />,
    <Route exact path="/admin/campaign/criar" component={CriarCampaign} />,
    <Route exact path="/admin/campaign/:id" component={EditarCampaign} />,
    <Route
      exact
      path="/admin/marketing/campanhas"
      component={MarketingCampanhas}
    />,
    <Route
      exact
      path="/admin/academy/cursos/:id_curso"
      component={EditarAcademyCursos}
    />,
    <Route
      exact
      path="/admin/academy/histories"
      component={ListarAcademyHistories}
    />,
    <Route
      exact
      path="/admin/inscricoes-eventos/criar"
      component={CriarInscricoesEventos}
    />,
    <Route
      exact
      path="/admin/inscricoes-eventos/enviar-emails"
      component={EnviarEmailsInscricoesEventos}
    />,
    <Route
      exact
      path="/admin/inscricoes-eventos/perfil/:id_inscricao"
      component={PerfilInscricoesEventos}
    />,

    //VoittoApp Routes
    <Route
      exact
      path="/admin/voittoapp/ratings"
      component={VoittoAppRatings}
    />,

    <Route exact path="/admin/voitto-jobs" component={VoittoJobs} />,

    // MBA
    <Route exact path="/admin/mba/list" component={MBAList} />,
    <Route exact path="/admin/mba/list/usuario" component={MBAListByUser} />,
    <Route exact path="/admin/mba/list/:id" component={MBAListOne} />,
    <Route exact path="/admin/mba/atribuir" component={MBAAtribuir} />,
    <Route exact path="/admin/mba/remover" component={MBARemover} />,
    <Route exact path="/admin/mba/documentos" component={MBADocumentos} />,
    <Route exact path="/admin/mba/listComplete" component={MBAListComplete} />,
    <Route exact path="/admin/mba/persist/:id" component={MBAListOnePersist} />,

    // RH
    <Route exact path="/admin/rh/vacancies" component={VacancyList} />,
    <Route exact path="/admin/rh/vacancies/create" component={CreateVacancy} />,
    <Route exact path="/admin/rh/vacancies/edit/:id" component={EditVacancy} />,
    <Route exact path="/admin/rh/bank-of-talents" component={BankOfTalents} />,

    // Dashboards
    <Route exact path="/admin/dashboard/mba" component={DashboardMBA} />,
    <Route
      exact
      path="/admin/dashboard/aluno/:id"
      component={DashboardAluno}
    />,

    // Aulas lições
    <Route exact path="/admin/resumos-de-aula" component={ResumosDeLicao} />,

    ...adminPocketBook,
  ];

  const mustMigrateRoutes = [
    <Route
      exact
      path="/indicacaoShow/:id"
      component={IndicacaoShow}
      notAdmin
    />,
    <Route
      exact
      path="/gratuitos-quarentena/:area?"
      component={GratuitosQuarentena}
      notAdmin
    />,
    <Route
      exact
      path="/online/meuscupons"
      component={MeusCupons}
      isPrivate
      notAdmin
    />,
    <Route exact path="/online/tickets/:id?" component={Tickets} notAdmin />,
    <Route
      exact
      path="/online/tickets/:id/editar/:idResposta"
      component={TicketsEdit}
      notAdmin
    />,
    <Route
      exact
      path="/online/certificados/:id?"
      component={Certificados}
      notAdmin
    />,
    <Route exact path="/pagar/:pedido?" component={Pagar} notAdmin />,
    <Route
      notAdmin
      exact
      path="/pagamento-especial/:plano"
      component={PagamentoVindi}
    />,
  ];

  // remoção das rotas antigas do Painel Empresa
  // const painelCorporativo = [
  // <Route
  //   exact
  //   path="/painelEmpresa/:empresa"
  //   component={PainelEmpresa}
  //   notAdmin
  // />,
  // <Route
  //   exact
  //   path="/universidade/:empresa"
  //   component={PortalAluno}
  //   notAdmin
  // />,
  // <Route
  //   exact
  //   path="/relatorioGeral/:empresa"
  //   component={RelatorioGeral}
  //   notAdmin
  // />,
  // ];

  return (
    <BrowserRouter>
      <Switch>
        {adminRoutes}
        {mustMigrateRoutes}
        {/* {painelCorporativo} */}

        <Route path="/login-react-js" component={LoginNode} notAdmin />
        <Route path="/cadastro" component={LoginNode} notAdmin />

        <Route exact path="/OAuth/" component={OAuth} notAdmin />
        <Route
          exact
          path="/OAuth/Logout/:redirect?"
          component={Logout}
          notAdmin
        />
        <Route path="/sair" component={SairNode} notAdmin />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
